// only available for client-side use
// where google analytics is installed

exports.getGAExperiments = () => {
  const ga = window.gaData;
  if ('object' === typeof(ga)) {
    return (ga[Object.keys(ga)[0]] || {}).experiments || {};
  }
  return {};
};
